import { HashAnchor } from 'components/HashAnchor';
import FormGroup from 'components/shared/FormGroup';
import InputTel from 'components/shared/InputTel';
import { Controller, useFormContext } from 'react-hook-form';
import { FormPhoneProps } from './FormPhone.types';

export const FormPhone: React.FC<FormPhoneProps> = ({
  name,
  formGroup = {},
  input = {}
}) => {
  const {
    control,
    formState: { errors }
  } = useFormContext();

  const onChangeHandler =
    input.onChange ||
    (() => {
      // NOOP
    });

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={''}
      render={({ field }) => (
        <FormGroup
          {...formGroup}
          forId={name}
          error={errors[name]?.message?.toString()}
        >
          <HashAnchor name={`anchor_${name}`} />
          <InputTel
            {...field}
            {...input}
            id={name}
            onChange={(val) => {
              field.onChange(val);
              onChangeHandler(val);
            }}
          />
        </FormGroup>
      )}
    />
  );
};
